import React, { Component } from "react";
import i18n from "live/services/i18n";
import type from "./decorator";
import Text from "./components/text";
import ActionToggle from "live/components/ui/action-toggle";

class DynamicLiveLookup extends Component {
  render() {
    const { onChange, validationState, errorsFor, config } = this.props;
    const outputParams = config.outputParams || {};
    const {
      cron = "",
      runNowSpan = "",
      restartDependencies = false,
    } = outputParams || {};

    return (
      <div>
        <Text
          label={i18n("Schedule")}
          value={cron}
          name="cron"
          onChange={(e) => onChange("cron", e)}
          validationState={validationState}
          help={
            errorsFor("config.schedule") ||
            i18n(
              "Period expression, or use 'realtime' to run immediately and follow results"
            )
          }
        />
        <div className="form-area">
          <label> {`Destroy lookup`}</label>
          <ActionToggle
            onChange={() => {
              onChange("restartDependencies", !restartDependencies);
            }}
            active={restartDependencies}
          />
        </div>
        <div className="form-area">
          <Text
            label={i18n("Optional: set span case save and run first time.")}
            value={runNowSpan}
            name="runNowSpan"
            onChange={(e) => onChange("runNowSpan", e)}
            validationState={validationState}
            help={errorsFor("config.runNowSpan")}
          />
        </div>
      </div>
    );
  }
}

export default type({
  label: "Dynamic Live Lookup",
  type: "dynamic",
  properties: ["cron", "runNowSpan", "destroyLookup"],
  config: {
    __validation_http_url: "cron(0 * * * *)",
  },
  validations: {
    __validation_dynamic_cron: {
      required: true,
      allowEmpty: false,
      message: i18n("cron is required"),
    },
  },
  validations: {
    __validation_dynamic_runNowSpan: {
      required: false,
      allowEmpty: false,
      message: i18n("cron is required"),
    },
  },
})(DynamicLiveLookup);
